import type { ReactNode } from "react";

import type { ComboboxOption } from "@/components/Combobox/types";
import { ControlledSelect } from "@/components/Select/ControlledSelect";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string;
  readComponent?: ReactNode;
  onChange: (deviceId?: string) => void;
  inputWidth?: number | string;
  inputClassName?: string;
  fetchOptions?: (text?: string) => Promise<ComboboxOption[]>;
  onSelectedOptionChange?: (option?: ComboboxOption) => void;
};

/**
 * Card-based Form / SelectItem
 */
export const CFormComboboxSelectItem = buildCFormItem((props: Props) => {
  const handleDeviceChange = (option?: ComboboxOption) => {
    props.onChange(option?.value);
    props.onSelectedOptionChange?.(option);
  };

  return (
    <CFormItemBase
      {...props}
      readComponent={props.readComponent ?? (props.value || "-")}
      writeComponent={
        <ControlledSelect
          id={props.id}
          value={props.value}
          onChange={handleDeviceChange}
          fetchOptions={props.fetchOptions}
          hideSearch={false}
          allowEmpty={!props.required}
          width={
            typeof props.inputWidth === "number" ? props.inputWidth : undefined
          }
          disabled={props.readonly}
        />
      }
    />
  );
});
